import React from 'react';
import { X, Image as ImageIcon } from 'lucide-react';

const AllImagesModal = ({ images, onClose, onImageSelect }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white max-w-6xl max-h-[80vh] w-full mx-4 overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h2 className="text-lg text-gray-900">
            All Related Images ({images.length})
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="p-4 overflow-y-auto max-h-[60vh]">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {images.map((image, idx) => (
              <div
                key={idx}
                className="border border-gray-200 p-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors"
                onClick={() => onImageSelect(idx)}
              >
                <div className="aspect-square mb-2">
                  <img
                    src={image.url}
                    alt={`${idx + 1}`}
                    className="w-full h-full object-cover bg-white"
                    loading="lazy"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                  <div
                    style={{ display: "none" }}
                    className="w-full h-full bg-gray-200 flex items-center justify-center text-gray-500"
                  >
                    <ImageIcon size={24} />
                  </div>
                </div>
                
                {image.document && (
                  <p className="text-xs text-gray-600 break-words mb-1">
                    <strong>Source:</strong> {image.document.split("/").pop()}
                  </p>
                )}
                
                {image.document_type && (
                  <span className="inline-block text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                    {image.document_type}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllImagesModal;